import { BankRegNr } from '@/domain/session';

export const BANKS_LEAVING = [BankRegNr.BANK2];
